<template>
  <a-layout :class="[flag ? null : 'active']">
    <!-- <global-header :menuData="menuData" :collapsed="collapsed" @toggleCollapse="toggleCollapse" /> -->

    <drawer v-if="isMobile" :openDrawer="collapsed" @change="onDrawerChange">
      <sider-menu
        :theme="theme"
        :menuData="menuData"
        :collapsed="false"
        :collapsible="false"
        @menuSelect="onMenuSelect"
      />
    </drawer>
    <!-- 左侧菜单-->
    <sider-menu
      :theme="theme"
      v-if="flag"
      :menuData="leftMenuData"
      :collapsed="collapsed"
      :collapsible="true"
    />

    <drawer :open-drawer="settingBar" placement="right"><setting /></drawer>

    <a-layout :style="{ paddingLeft: paddingLeft }">
      <!--头部菜单-->
      <global-header
        :menuData="topMenuData"
        :collapsed="collapsed"
        @toggleCollapse="toggleCollapse"
        @menuSelect="onMenuSelect"
      />
      <a-layout-content
        :style="{ minHeight: minHeight, margin: 0 }"
        :class="fixHeader ? 'fixed-header-content' : null"
        ><slot></slot
      ></a-layout-content>
      <!-- <a-layout-footer style="padding: .29rem 0" class="copyright"><global-footer :copyright="copyright" /></a-layout-footer> -->
    </a-layout>
  </a-layout>
</template>

<script>
import GlobalHeader from "./GlobalHeader";
import GlobalFooter from "./GlobalFooter";
import Drawer from "~/tool/Drawer";
import SiderMenu from "~/menu/SiderMenu";
import Setting from "~/setting/Setting";
import { mapState, mapMutations } from "vuex";
import { triggerWindowResizeEvent } from "utils/common";
// import bus from './bus.js';
import db from "utils/localstorage";

const minHeight = window.innerHeight - 64 - 24 - 66;

let menuData = [];
let leftMenuData = [];
let topMenuData = [];
export default {
  name: "GlobalLayout",
  components: { Setting, SiderMenu, Drawer, GlobalFooter, GlobalHeader },
  data() {
    return {
      minHeight: minHeight + "px",
      collapsed: false,
      menuData: menuData,
      leftMenuData: leftMenuData,
      topMenuData: topMenuData,
      flag: false,
    };
  },
  computed: {
    paddingLeft() {
      return this.fixSiderbar && this.layout === "side" && !this.isMobile
        ? `${this.sidebarOpened ? 256 : 80}px`
        : "0";
    },
    ...mapState({
      sidebarOpened: (state) => state.setting.sidebar.opened,
      isMobile: (state) => state.setting.isMobile,
      theme: (state) => state.setting.theme,
      layout: (state) => state.setting.layout,
      copyright: (state) => state.setting.copyright,
      fixSiderbar: (state) => state.setting.fixSiderbar,
      fixHeader: (state) => state.setting.fixHeader,
      settingBar: (state) => state.setting.settingBar.opened,
    }),
  },
  methods: {
    ...mapMutations({ setSidebar: "setting/setSidebar" }),
    toggleCollapse() {
      this.collapsed = !this.collapsed;
      // console.log(this.collapsed);
      this.setSidebar(!this.collapsed);
      triggerWindowResizeEvent();
    },
    onDrawerChange(show) {
      this.collapsed = show;
    },
    onMenuSelect(item) {
      this.menuData.forEach((i) => {
        if (item.key === i.path) {
          this.leftMenuData = i.children || [];
          // console.log(this.leftMenuData.length)
          if (this.leftMenuData.length === 0) {
            this.flag = false;
          } else {
            this.flag = true;
          }
        }
      });

      // this.toggleCollapse();
    },
    initData() {
      // debugger
      let routers = this.$db.get("USER_ROUTER");
      menuData = routers
        .find((item) => item.path === "/")
        .children.filter((menu) => {
          // console.log(menu)
          let meta = menu.meta;
          if (typeof meta.isShow === "undefined") {
            return true;
          } else return meta.isShow;
        });
      let routes = this.$route.matched.concat();
      menuData.forEach((item) => {
        routes.forEach((r) => {
          if (r.regex.test(item.path)) {
            this.leftMenuData = item.children || [];
            if (this.leftMenuData.length === 0) {
              // 初始化先判断是否有二级菜单，控制左侧显示隐藏
              this.flag = false;
            } else {
              this.flag = true;
            }
          }
        });
      });
      // console.log(menuData);
      // 处理左侧默认第一个菜单选项
      // 判断左侧是否有三级菜单，如果有则显示二级菜单下三级菜单的第一个
      let threeLevel = this.leftMenuData.filter((item) => item.children);
      if (threeLevel) {
        // 如果有三级菜单
        threeLevel.map((item) => {
          item.children.map((e) => {
            // console.log(e)
            (e.meta.isShow = false), (e.meta.closeable = false);
            // (item.meta.isShow = false), (item.meta.closeable = false);
          });
          try {
            this.leftMenuData[0].children[0].meta.isShow = true;
          } catch (e) {
            // TODO handle the exception
          }
        });
      } else {
        this.leftMenuData.map((item) => {
          // (item.icon = menuData[1].icon),
          (item.meta.isShow = false), (item.meta.closeable = false);
        });
        try {
          this.leftMenuData[0].meta.isShow = true;
        } catch (e) {
          // TODO handle the exception
        }
      }

      // 处理头部数据
      // 不显示子级，删除children
      // 先做一个深拷贝
      this.topMenuData = JSON.parse(JSON.stringify(menuData));
      this.topMenuData.map((item) => {
        if (item.children) {
          // 若存在二级菜单，则点击默认为二级菜单的第一个
          item.newPath = item.children ? item.children[0].path : item.path;
          // 若当前二级菜单的第一个存在三级菜单，则点击默认为三级菜单的第一个
          if (item.children[0].children) {
            item.newPath = item.children[0].children
              ? item.children[0].children[0].path
              : item.path;
          }
          // 此时隐藏二级菜单，只显示头部菜单即可
          item.children = null;
        }
      });
      // bus.$emit('pathValue', JSON.stringify(this.topMenuData))
      db.save("pathValue", this.topMenuData); // 存入缓存，已备首页进路由使用过
    },
  },
  beforeCreate() {
    let routers = this.$db.get("USER_ROUTER");
    menuData = routers
      .find((item) => item.path === "/")
      .children.filter((menu) => {
        let meta = menu.meta;
        if (typeof meta.isShow === "undefined") {
          return true;
        } else return meta.isShow;
      });

    // 数据结构 name path
  },
  watch: {
    $route(to, from) {
      this.initData();
    },
  },
  mounted() {
    // 取得地址栏的当前地址，计算出响应的数组信息
    this.initData();

    //
  },
};
</script>

<style lang="less" scoped>
.setting {
  background-color: #1890ff;
  color: #fff;
  border-radius: 5px 0 0 5px;
  line-height: 40px;
  font-size: 22px;
  width: 40px;
  height: 40px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}
.fixed-header-content {
	margin-top: 64px!important;
}
.active .ant-layout {
  padding-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/common/GlobalLayout.vue